import axiosInstance from './axiosConfig';

interface S3UploadResponse {
  id: number;
  type: string;
  url: string;
  s3_url?: string;
  s3_key?: string;
  filename: string;
  mime_type: string;
  size: number;
}

class S3UploadService {
  /**
   * 画像ファイルをS3にアップロード
   * @param file アップロードするファイル
   * @returns アップロード結果
   */
  async uploadImageToS3(file: File): Promise<S3UploadResponse | null> {
    try {
      // 画像ファイルかチェック
      if (!file.type.startsWith('image/')) {
        console.log('Not an image file:', file.type);
        return null;
      }

      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'image');

      const response = await axiosInstance.post<S3UploadResponse>(
        '/api/attachments',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      // APIレスポンスはattachmentオブジェクトにラップされている
      const attachment = (response.data as any).attachment || response.data;

      console.log('Image uploaded to S3:', {
        filename: attachment.filename,
        s3_url: attachment.s3_url,
        s3_key: attachment.s3_key
      });

      return attachment;
    } catch (error) {
      console.error('Failed to upload image to S3:', error);
      return null;
    }
  }

  /**
   * 複数の画像ファイルをS3にアップロード
   * @param files アップロードするファイル配列
   * @returns アップロード結果の配列
   */
  async uploadImagesToS3(files: File[]): Promise<(S3UploadResponse | null)[]> {
    const imageFiles = files.filter(file => file.type.startsWith('image/'));
    
    if (imageFiles.length === 0) {
      return [];
    }

    const uploadPromises = imageFiles.map(file => this.uploadImageToS3(file));
    return Promise.all(uploadPromises);
  }
}

export default new S3UploadService();